import React from 'react';
import { Flex, Box, Text } from 'rebass/styled-components';
import { ProfilePicture } from '@getro/rombo';
import { ContactEmailDropdown } from 'components/molecules/contactEmailDropdown';
import PropTypes from 'prop-types';
import { Linkedin } from 'lucide-react';

export const CandidateNameRenderer = ({ data }) => {
  const { original } = data;

  const fullName = `${original.firstName} ${original.lastName}`;

  return (
    <Flex
      alignItems="flex-start"
      width="100%"
      p="8px"
      pl="16px"
      sx={{
        gap: '8px',
        width: '100%',
        flexDirection: 'row',
      }}
    >
      <Box width="24px" height="24px">
        <ProfilePicture imageUrl={original.profilePictureUrl} name={fullName} />
      </Box>
      <Flex sx={{ gap: '4px', flexDirection: 'column' }}>
        <Text
          fontSize="14px"
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color: 'text.dark',
            fontSize: '14px',
            fontWeight: '500',
            lineHeight: '24px',
          }}
        >
          {fullName}
        </Text>
        <Flex flex="0 0 auto" sx={{ alignItems: 'center', gap: '16px' }}>
          {original.linkedinUrl && (
            <Box
              as={Linkedin}
              height="16px"
              width="16px"
              aria-hidden="true"
              aria-label="LinkedIn"
              title="LinkedIn"
              sx={{ cursor: 'pointer' }}
              onClick={() => window.open(original.linkedinUrl, '_blank', 'noopener,noreferrer')}
            />
          )}
          <ContactEmailDropdown contact={original} showTooltip={false} />
        </Flex>
      </Flex>
    </Flex>
  );
};

CandidateNameRenderer.propTypes = {
  data: PropTypes.object,
};

CandidateNameRenderer.defaultProps = {
  data: {},
};
